export const CHATS_CHANNEL = 'chats_channel';

export function getBroadcastChannel(): BroadcastChannel | undefined {
  if (typeof window === 'undefined' || typeof BroadcastChannel === 'undefined') {
    return;
  }

  /** Канала нет или он уже закрыт */
  if (!window.__chatsBroadcastChannel || window.__chatsBroadcastChannel.name === '') {
    window.__chatsBroadcastChannel = new BroadcastChannel(CHATS_CHANNEL);
  }

  return window.__chatsBroadcastChannel;
}
